import { destinationGroups } from './destination-groups';
import { socialMedia } from './social-media';

export const v4 = {
  destinationGroups,
  socialMedia,
};
